import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
    apiKey: "AIzaSyD-9oIS7xwDUsUEveErD2lQJos2k6406yI",
    authDomain: "portal-ikas.firebaseapp.com",
    projectId: "portal-ikas",
    storageBucket: "portal-ikas.firebasestorage.app",
    messagingSenderId: "446733143049",
    appId: "1:446733143049:web:1592bef1394fa7aaf8bcd8",
    measurementId: "G-TB1GBGCEPN"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

export default db;
